var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ui-chip",class:[_vm.tone && _vm.tone !== 'plain' && `ui-chip--${_vm.tone}`, _vm.pill && 'ui-chip--pill', _vm.tag && 'ui-chip--tag']},[(_vm.dot)?_c('i',{staticClass:"ui-dot"}):(_vm.icon)?_c('v-icon',{attrs:{"size":"13","color":"currentColor"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }